import React from 'react'
import Container from '~/components/Container'
import Typography from '~/components/Typography'
import { cn } from '~/utils/cn'

export type PageProps = PropsWithClassName<{
  children: React.ReactNode
  disableContainer?: boolean
  title?: string
  subtitle?: string
}>

const Page = ({
  children,
  className,
  title,
  subtitle,
  disableContainer = false
}: PageProps) => {
  const ContentWrapper = disableContainer ? Container : 'div'
  const content = title ? (
    <ContentWrapper className="mb-12 flex flex-col gap-y-1">
      {subtitle ? (
        <Typography family="body" component="span" variant="h5" color="shy">
          {subtitle}
        </Typography>
      ) : null}
      <Typography family="brand" variant="h1" className="text-balance">
        {title}
      </Typography>
    </ContentWrapper>
  ) : null

  return !disableContainer ? (
    <Container
      component="main"
      className={cn('pb-12 pt-12 md:pb-60', className)}
    >
      {content}
      {children}
    </Container>
  ) : (
    <main className={cn('pb-12 pt-12 md:pb-60', className)}>
      {content}
      {children}
    </main>
  )
}

export default Page
